import styled, {css, keyframes} from 'styled-components';

import {ContentContainer} from 'components/ui-kit/PageComponents';
import {Tag} from 'components/ui-kit/Tags';
import {border, colors, font} from 'theme';

export const SpinnerLayer = styled.div`
    display: flex;
    height: 50vh;
    flex: 1;
    justify-content: center;
    align-items: center;
    min-height: 80px;
    background-color: ${colors.white};
    border-radius: ${border.radius};
`;

export const ContentWrapper = styled(ContentContainer)``;

export const HeadContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
`;

export const Headline = styled.h1`
    display: inline-flex;
    white-space: nowrap;
    margin: 0;
    padding: 0;
    width: auto;
    height: auto;
    font-family: ${font.family.primary};
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-transform: uppercase;
    color: ${colors.black};
`;

export const HeadControl = styled.div`
    width: auto;
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
`;

export const Id = styled.span`
    font-family: ${font.family.primary};
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: ${colors.brandPrimary};
`;

export const FormField = styled.div`
    margin-bottom: 15px;
`;

export const FormContainer = styled.div`
    padding-bottom: 60px;
    box-sizing: border-box;
    position: relative;
`;

export const NavigationButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    width: 100%;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
`;

export const Column = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 200px;
    margin: 0 5px 5px 5px;
`;

export const Fieldset = styled.fieldset`
    border: none;
    padding: 0;
`;

export const FormPartTitle = styled.div`
    font-weight: 700;
    font-size: 12px;
`;

export const DeleteCodeContainer = styled.div<{disabled?: boolean}>`
    padding: 5px;
    cursor: pointer;
    ${({disabled}) =>
        disabled &&
        css`
            pointer-events: none;
            cursor: default;
            opacity: 0.3;
        `}
`;

export const DatePickerField = styled.div`
    width: 100%;
`;

export const StatusWrapper = styled(Tag)`
    padding: 7px 10px;
    font-weight: 500;
    font-size: 14px;
    line-height: 12px;
`;
